const WEEKDAYS_PT = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

function nextFourWeeklyDates() {
  const base = new Date();
  base.setDate(base.getDate() + 7);
  const results = [];
  for (let i = 0; i < 4; i += 1) {
    const d = new Date(base);
    d.setDate(base.getDate() + i * 7);
    results.push(d);
  }
  return results;
}

function formatDate(date) {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  return `${day}/${month}`;
}

function formatGCalDate(date, hour = 20) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  const h = String(hour).padStart(2, '0');
  return `${y}${m}${d}T${h}0000`;
}

function buildCalendarUrl(dates, hour = 20) {
  const start = formatGCalDate(dates[0], hour);
  const end = formatGCalDate(dates[0], hour + 1);
  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: '🦜 Prática de inglês na Guará Chat',
    details: 'Sua sessão semanal de prática de inglês. O link da sala será enviado pelo WhatsApp 30 minutos antes. 🎯',
    dates: `${start}/${end}`,
    recur: 'RRULE:FREQ=WEEKLY;COUNT=4',
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

const cardStyle = {
  flex: 1,
  padding: '10px 4px',
  textAlign: 'center',
};

const dateStyle = {
  color: '#fff',
  fontSize: 12,
  fontWeight: 700,
  marginTop: 4,
  fontFamily: "'League Spartan', Arial, sans-serif",
};

const dayStyle = {
  color: 'rgba(255,255,255,0.6)',
  fontSize: 11,
  fontFamily: "'League Spartan', Arial, sans-serif",
};

const ctaStyle = {
  background: '#fff',
  color: '#55B4BE',
  border: 'none',
  borderRadius: 100,
  padding: '12px 20px',
  fontWeight: 700,
  fontSize: 15,
  cursor: 'pointer',
  width: '100%',
  fontFamily: "'League Spartan', Arial, sans-serif",
};

const skipStyle = {
  background: 'transparent',
  color: 'rgba(255,255,255,0.5)',
  border: 'none',
  fontSize: 14,
  cursor: 'pointer',
  fontFamily: "'League Spartan', Arial, sans-serif",
};

export default function HabitPrompt({ onAnswer }) {
  const dates = nextFourWeeklyDates();
  const weekday = WEEKDAYS_PT[dates[0].getDay()];
  const calendarUrl = buildCalendarUrl(dates);

  const handleYes = () => {
    window.open(calendarUrl, '_blank', 'noopener,noreferrer');
    onAnswer(true);
  };

  const handleNo = () => {
    onAnswer(false);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16, width: '100%' }}>
      <span className="checkout-title">Topa construir o hábito com mais 4 sessões?</span>
      <span className="checkout-subtitle" style={{ fontSize: 17, opacity: 0.7, marginTop: -8 }}>Parceiros podem variar.</span>

      <div style={{ display: 'flex', gap: 8, width: '100%' }}>
        {dates.map((date) => (
          <div key={date.toISOString()} style={cardStyle}>
            <div style={{ fontSize: 14 }}>🔵</div>
            <div style={dateStyle}>{formatDate(date)}</div>
            <div style={dayStyle}>{weekday} · 20h</div>
          </div>
        ))}
      </div>

      <button type="button" style={{ ...ctaStyle, marginTop: 24 }} onClick={handleYes}>
        Sim! Adicionar ao meu calendário 📅
      </button>
      <button type="button" style={skipStyle} onClick={handleNo}>
        Agora não
      </button>
    </div>
  );
}
